import React from "react";
import PaymentDetailsRow from "./paymentDetailsRow.jsx";
import { currencyFormatter } from "./../../utils/display";

export default ({ payments, openPaymentDetailsModal }) => {
  const paymentTotal = payments.reduce(
    (sum, payment) => sum + Number(payment.amount),
    0
  );
  return (
    <div className="acct-border-btm payments-panel">
      <div className="acct-txt-14 payment-heading-container">
        <div className="flex-column">
          <div className="payment-heading">
            <strong>Payments</strong>
          </div>
        </div>
      </div>
      <table className="payment-table">
        <thead>
          <tr className="payment-row">
            <th className="acct-txt-sm payment-cell">Date</th>
            <th className="acct-txt-sm payment-cell">ID</th>
            <th className="acct-txt-sm payment-cell">Status</th>
            <th className="acct-txt-sm payment-cell">Amount</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment, key) => (
            <PaymentDetailsRow
              payment={payment}
              openPaymentDetailsModal={openPaymentDetailsModal}
              key={key}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
